
import createDeferredScreen from "./createDeferredScreen";

export const Appreciation = createDeferredScreen(() => import('./appreciation/appreciation'));
export const Dashboard = createDeferredScreen(() => import('./dashboard/dashboard'));
export const PharmacyBookMarksList = createDeferredScreen(() => import('./dashboard/bookmarks/bookmarkList'));
export const ChangeLog = createDeferredScreen(() => import('./changeLog/changeLog'));
export const RealtimeDemoPage = createDeferredScreen(() => import('./realtime/RealtimeDemoPage'));

export const AllRequests = createDeferredScreen(() => import('./timeOffRequest/allRequests'));
export const NewRequest = createDeferredScreen(() => import('./timeOffRequest/newRequest'));
export const TimeSchedule = createDeferredScreen(() => import('./timeSheet/timeSchedule'));

export const MyProfile = createDeferredScreen(() => import('./myProfile/myProfile'));
export const AddPatients = createDeferredScreen(() => import('./pharmacy/patients/addPatients'));
export const PharmacyPatientProfile = createDeferredScreen(() => import('./pharmacy/patients/patientProfile'));
export const Settings = createDeferredScreen(() => import('./settings/settings'));
export const AllEmployees = createDeferredScreen(() => import('./teams/employees/allEmployees'));
export const EditRequest = createDeferredScreen(() => import('./timeOffRequest/editRequest'));
export const AllPatientsList = createDeferredScreen(() => import('./pharmacy/patients/patientsList'));
export const PharmacyPrintOatLog = createDeferredScreen(() => import('./pharmacy/patients/printOatLog'));

export const RxTransferForm = createDeferredScreen(() => import('./pharmacy/forms/RxTransferRequest'));
export const PharmacyInformationUpdateForm = createDeferredScreen(() => import('./pharmacy/forms/pharmacyInformationUpdateForm'));
export const DrNotificationForEmergencySupply = createDeferredScreen(() => import('./pharmacy/forms/DrNotificationforEmergencySupply'));
export const MixingRxRequirementsForm = createDeferredScreen(() => import('./pharmacy/forms/MissingRxRequirementsForm'));
export const AntiViralRequestForm = createDeferredScreen(() => import('./pharmacy/forms/antiViralRequestForms'));
export const EmergencySupplyForContinuityOfCareForm = createDeferredScreen(() => import('./pharmacy/forms/EmergencySupplyForContinuityofCareForm'));
export const PatientAgreementForTakeHomeDosing = createDeferredScreen(() => import('./pharmacy/forms/PatientAgreementForTakeHomeDosing'));
export const DoctorCommunicationForm = createDeferredScreen(() => import('./pharmacy/forms/doctorCommunicationForm'));
export const PlanGForm = createDeferredScreen(() => import('./pharmacy/forms/planGForm'));
export const PlanZForm = createDeferredScreen(() => import('./pharmacy/forms/planZForm'));
export const AddDoctorNote = createDeferredScreen(() => import('./pharmacy/forms/AddDr_noteForm'));
export const TBSkinMantouxForm = createDeferredScreen(() => import('./pharmacy/forms/TBSkinTest(Mantoux Test)ReportForm'));
export const TbSkinTestLogs = createDeferredScreen(() => import('./pharmacy/forms/TbSkinTestLogs'));
export const PharmacistPrescriberCommunication = createDeferredScreen(() => import('./pharmacy/forms/pharmacistPrescriberCommunication'));
export const RxCopyOfOriginalForOatDD = createDeferredScreen(() => import('./pharmacy/forms/RxCopyOriginalforOAT_DD'));
export const TBScreeningForm = createDeferredScreen(() => import('./pharmacy/forms/Tb_screening_form'));
export const TbScreeningFormsLogs = createDeferredScreen(() => import('./pharmacy/forms/Tb_sscreening_forms_logs'));
export const Pharmacare = createDeferredScreen(() => import('./pharmacy/forms/pharmacare'));

export const PharmacyEmployeesTaskList = createDeferredScreen(() => import('./pharmacy/dashboard/tasksList'));
export const PharmacyTeamNotes = createDeferredScreen(() => import('./pharmacy/dashboard/teamNotes'));
export const GeneralInformation = createDeferredScreen(() => import('./pharmacy/others/generalInformation'));
export const AllNotifications = createDeferredScreen(() => import('./pharmacy/dashboard/allNotifications'));
export const SentFaxLogs = createDeferredScreen(() => import('./pharmacy/dashboard/sentFaxLogs'));
export const ReminderNotifications = createDeferredScreen(() => import('./pharmacy/dashboard/newReminderNotifications'));
export const DeliveredRxReasons = createDeferredScreen(() => import('./pharmacy/dashboard/deliveredRxReasons'));
export const PharmacyFrontProfile = createDeferredScreen(() => import('./settings/pharmacyProfile'));

export const CompoundAggrementForm = createDeferredScreen(() => import('./pharmacy/compounds/compoundAggrementForm'));
export const EditCompoundPriceList = createDeferredScreen(() => import('./pharmacy/compounds/editCompoundPriceList'));
export const CompoundPriceList = createDeferredScreen(() => import('./pharmacy/compounds/priceList'));
export const CompoundOrderForm = createDeferredScreen(() => import('./pharmacy/compounds/CompoundOrderForm'));
export const ControlledSubstancesOrderRequestForm = createDeferredScreen(() => import('./pharmacy/compounds/ControlledSubstancesOrderRequestForm'));
export const OrderCompoundingForm = createDeferredScreen(() => import('./pharmacy/compounds/compoundingOrder'));
export const CompoundQuotation = createDeferredScreen(() => import('./pharmacy/compounds/compoundQuotation'));
export const CompoundDueBilling = createDeferredScreen(() => import('./pharmacy/compounds/compoundDueBilling'));

export const DeliveryDeriverManagement = createDeferredScreen(() => import('./pharmacy/dispense/deliveryDeriverManagement'));
export const ArchivedDispense = createDeferredScreen(() => import('./pharmacy/dispense/archivedDelivery'));
export const DriverClinicCallLogs = createDeferredScreen(() => import('./pharmacy/dispense/driverClinicCallLogs'));
export const DeliveryLabels = createDeferredScreen(() => import('./pharmacy/dispense/deliveryLabels'));
export const PharmacyMemo = createDeferredScreen(() => import('./pharmacy/dispense/pharmacyMemo'));
export const SignCheckAI = createDeferredScreen(() => import('./pharmacy/dispense/signCheckAI'));
export const ExpiringRx = createDeferredScreen(() => import('./pharmacy/dispense/expiringRx'));
export const ExpiringRxV2 = createDeferredScreen(() => import('./pharmacy/dispense/expiringRxV2'));
export const ConsentSubmissions = createDeferredScreen(() => import('./pharmacy/dispense/consentSubmissions'));
export const Counselling = createDeferredScreen(() => import('./pharmacy/dispense/counselling'));
export const BillingList = createDeferredScreen(() => import('./pharmacy/dispense/billing'));
export const PrescriptionsList = createDeferredScreen(() => import('./pharmacy/dispense/prescripitions'));
export const OnGoingPrescriptions = createDeferredScreen(() => import('./pharmacy/dispense/onGoingPrescripitions'));
export const ReturnedFentanylPatches = createDeferredScreen(() => import('./pharmacy/dispense/returnedFentanylPatches'));
export const FentanylPatchLog = createDeferredScreen(() => import('./pharmacy/dispense/fentanylPatchLog/FentanylPatchLog'));
export const TransferConsentsForms = createDeferredScreen(() => import('./pharmacy/dispense/transferConsents'));
export const Accountability = createDeferredScreen(() => import('./pharmacy/dispense/accountability'));
export const PharmacyDWIPatientsData = createDeferredScreen(() => import('./pharmacy/dispense/DWI_PatientsData'));
export const PharmacyInvestigationRX = createDeferredScreen(() => import('./pharmacy/dispense/investigationRX'));
export const PharmacyPharmanetProfile = createDeferredScreen(() => import('./pharmacy/dispense/pharmanetProfilePage'));
export const RxNumberDateSync = createDeferredScreen(() => import('./pharmacy/dispense/rxNumberDateSync'));
// export { default as PharmacyInvestigationRX } from './pharmacy/dispense/investigationRX';
export const AddNewPharmacistSignatures = createDeferredScreen(() => import('./pharmacy/dispense/pharmacistSignatureUpdation'));
export const uploadePrescription = createDeferredScreen(() => import('./pharmacy/dispense/uploadePrescription'));
export const PharmacyReversedDelveries = createDeferredScreen(() => import('./pharmacy/dispense/PharmacyReversedDelveries'));
export const PharmacyPatientSoapNotes = createDeferredScreen(() => import('./pharmacy/dispense-SoapNotes/patientSoapNotes'));
export const PharmacyInvestigationRXSignatureRequested = createDeferredScreen(() => import('./pharmacy/dispense/investigatingRX_SignaturesRequested'));
export const MedReviewLogs = createDeferredScreen(() => import('./pharmacy/dispense-SoapNotes/medReviewLogs'));
export const CreateSoapNotes = createDeferredScreen(() => import('./pharmacy/dispense-SoapNotes/createSoapNotes'));
export const SoapNotesLogs = createDeferredScreen(() => import('./pharmacy/dispense-SoapNotes/soapNotesLogs'));
export const MedReviewLog = createDeferredScreen(() => import('./pharmacy/dispense-SoapNotes/medReviewLog'));
export const PatientMedReviewSign = createDeferredScreen(() => import('./pharmacy/dispense-SoapNotes/patientMedReviewSign'));

export const AddBlisterPack = createDeferredScreen(() => import('./pharmacy/blisters/addBlisterPack'));
export const BlisterPatients = createDeferredScreen(() => import('./pharmacy/blisters/blisterPatientsList'));
export const BlistersPackList = createDeferredScreen(() => import('./pharmacy/blisters/blisterPacks'));
export const DailyPacksList = createDeferredScreen(() => import('./pharmacy/blisters/dailyPacks'));
export const BlisterPacksOnShelf = createDeferredScreen(() => import('./pharmacy/blisters/blisterPacksOnShelf'));
export const BlisterSheets = createDeferredScreen(() => import('./pharmacy/blisters/newBlisterSheet'));
export const OldBlisterSheets = createDeferredScreen(() => import('./pharmacy/blisters/blisterSheets'));

export const VialsPatients = createDeferredScreen(() => import('./pharmacy/vials/vialsPatientList'));
export const AddVialsPatient = createDeferredScreen(() => import('./pharmacy/vials/addVialsPack'));
export const VialsPackList = createDeferredScreen(() => import('./pharmacy/vials/vialsPackList'));
export const DailyVialsList = createDeferredScreen(() => import('./pharmacy/vials/dailyVials'));

export const MedicationPatients = createDeferredScreen(() => import('./pharmacy/specialityMedication/medicationsPatients'));
export const AddMedicationPatients = createDeferredScreen(() => import('./pharmacy/specialityMedication/addMedicationPack'));
export const SpecialtyMedicationPackList = createDeferredScreen(() => import('./pharmacy/specialityMedication/specialityMedicationPacks'));
export const DailySpecialityMedicationList = createDeferredScreen(() => import('./pharmacy/specialityMedication/dailySpecialityMedication'));

export const GenerateInvoice = createDeferredScreen(() => import('./pharmacy/Invoice/generateInvoice'));
export const PreviousInvoicesList = createDeferredScreen(() => import('./pharmacy/Invoice/previousInvoiceNumber'));

export const addARV = createDeferredScreen(() => import('./pharmacy/arv/addARV'));
export const ArvList = createDeferredScreen(() => import('./pharmacy/arv/arvList'));

export const DailyRevenue = createDeferredScreen(() => import('./pharmacy/revenue/dailyRevenue'));
export const CashChange = createDeferredScreen(() => import('./pharmacy/revenue/cashChange'));
export const DepositInformation = createDeferredScreen(() => import('./pharmacy/revenue/depositInfo'));
export const InHandCashInfo = createDeferredScreen(() => import('./pharmacy/revenue/InHandCash'));

export const CreateNewFDAForm = createDeferredScreen(() => import('./pharmacy/FDAForms/createNewFDAForm'));
export const ALLGeneratedFDAformList = createDeferredScreen(() => import('./pharmacy/FDAForms/allGeneratedFDAForms'));
export const ExpiringFDAList = createDeferredScreen(() => import('./pharmacy/FDAForms/expiringFDAFormList'));
export const ExpiredFDAList = createDeferredScreen(() => import('./pharmacy/FDAForms/expiredFDAList'));
export const FDAAudit = createDeferredScreen(() => import('./pharmacy/FDAForms/fdaAudit'));
export const FDATimeline = createDeferredScreen(() => import('./pharmacy/FDAForms/fdaTimeline'));


export const PatientRoute = createDeferredScreen(() => import('./pharmacy/OAT/patientRoute'));
export const AddOatPatientPack = createDeferredScreen(() => import('./pharmacy/OAT/addOatPatient'));

export const InventoryList = createDeferredScreen(() => import('./pharmacy/Inventory/inventorylist'));
export const InventoryAccountability = createDeferredScreen(() => import('./pharmacy/Inventory/inventoryAccountability'));
export const FridgeTemperatureLog = createDeferredScreen(() => import('./pharmacy/Inventory/fridgeTemperatureLog'));

export const AddTravelPatients = createDeferredScreen(() => import('./pharmacy/Travel/addTravelPatients'));
export const TravelPatients = createDeferredScreen(() => import('./pharmacy/Travel/tarvelPatients'));
export const TravelLogs = createDeferredScreen(() => import('./pharmacy/Travel/travelLogs'));
export const BillingDueList = createDeferredScreen(() => import('./pharmacy/Travel/billingDue'));
export const ReturningPatientsList = createDeferredScreen(() => import('./pharmacy/Travel/returningPatients'));

export const TransferPrescriptions = createDeferredScreen(() => import('./pharmacy/app/transferPrescriptions'));
export const NewPrescriptionList = createDeferredScreen(() => import('./pharmacy/app/newPrescription'));
export const AppPrescriptions = createDeferredScreen(() => import('./pharmacy/app/appPrescriptions'));
export const ViewOrderDetails = createDeferredScreen(() => import('./pharmacy/app/viewOrderDetails'));
export const AppUser = createDeferredScreen(() => import('./pharmacy/app/appUserList'));
export const RefillRequest = createDeferredScreen(() => import('./pharmacy/app/refillRequest'));
export const AppAnnouncements = createDeferredScreen(() => import('./pharmacy/app/appAnnouncements'));
export const AppCustomNotification = createDeferredScreen(() => import('./pharmacy/app/appCustomNotification'));
export const PatientChat = createDeferredScreen(() => import('./pharmacy/app/patientChat'));
export const PharmacyAppServices = createDeferredScreen(() => import('./pharmacy/app/pharmacyServices'));
export const InsuranceDocuments = createDeferredScreen(() => import('./pharmacy/app/insuranceDocuments'));
export const BreakPayrollSetting = createDeferredScreen(() => import('./settings/breakPayrollSetting'));

export const PharmacyStatHolidays = createDeferredScreen(() => import('./settings/pharmacyStatHolidays'));

export const BookAppointments = createDeferredScreen(() => import('./pharmacy/appointments/bookAppointments'));
export const AppointmentLogs = createDeferredScreen(() => import('./pharmacy/appointments/appointmentLogs'));

export const PackagingOrderPreview = createDeferredScreen(() => import('./pharmacy/packaging/packagingOrderPreview'));
export const CreateNewOrder = createDeferredScreen(() => import('./pharmacy/packaging/createNewOrder'));
export const AllPackagingOrders = createDeferredScreen(() => import('./pharmacy/packaging/allPackagingOrders'));
export const MyPackmedFiles = createDeferredScreen(() => import('./pharmacy/packaging/myPackmedFiles'));
export const PacmedDinManagement = createDeferredScreen(() => import('./pharmacy/packaging/dinManagement'));
export const PackgingLiquidProcessing = createDeferredScreen(() => import('./pharmacy/packaging/liquidProcessing'));
export const PackgingPRNProcessing = createDeferredScreen(() => import('./pharmacy/packaging/PRN_Processing'));
export const AllInvoices = createDeferredScreen(() => import('./pharmacy/packaging/All_Invoices'));
export const PackagingMonthlyInvoice = createDeferredScreen(() => import('./pharmacy/packaging/monthlyInvoice'));

export const VaccinePassPort = createDeferredScreen(() => import('./pharmacy/vaccines/newVaccinePass_port'));
export const VaccineLogs = createDeferredScreen(() => import('./pharmacy/vaccines/vaccineLogs'));

export const PharmacySmsTabs = createDeferredScreen(() => import('./pharmacy/sms/smsTabs'));

export const CreateBlisterPackagingNewOrder = createDeferredScreen(() => import('./pharmacy/blisterPackaging/createNewOrder'));
export const BlisterPackgingPRNProcessing = createDeferredScreen(() => import('./pharmacy/blisterPackaging/PRN_Processing'));
export const BlisterPackgingLiquidProcessing = createDeferredScreen(() => import('./pharmacy/blisterPackaging/liquidProcessing'));
export const BlisterPackagingAllOrders = createDeferredScreen(() => import('./pharmacy/blisterPackaging/allPackagingOrders'));
export const BlisterPackagingPackmedFiles = createDeferredScreen(() => import('./pharmacy/blisterPackaging/myPackmedFiles'));
export const BlisterPackagingAllInvoices = createDeferredScreen(() => import('./pharmacy/blisterPackaging/All_Invoices'));
export const BlisterPackagingMonthlyInvoice = createDeferredScreen(() => import('./pharmacy/blisterPackaging/monthlyInvoice'));

export const AccountabilityNewRx = createDeferredScreen(() => import('./pharmacy/Accountability/accountabilityNewRx'));
export const PrepCheck = createDeferredScreen(() => import('./pharmacy/Accountability/prepCheckTabsPage'));
export const PickupLog = createDeferredScreen(() => import('./pharmacy/Accountability/preparingCheckPickupLog'));
export const FinalCheck = createDeferredScreen(() => import('./pharmacy/Accountability/finalCheck'));
export const TodayMissedRx = createDeferredScreen(() => import('./pharmacy/Accountability/todayMissedRx'));
export const AccountabilityAllReports = createDeferredScreen(() => import('./pharmacy/Accountability/accountabilityAllReports'));
export const PrepForNewRx = createDeferredScreen(() => import('./pharmacy/Accountability/prepForNewRx'));
export const AfterProcessPrepCheck = createDeferredScreen(() => import('./pharmacy/Accountability/afterProcessPrepCheck/AfterProcessPrepCheck'));
export const PharmacyMarkFlexi = createDeferredScreen(() => import('./pharmacy/Accountability/pharmacyMarkFlexi/PharmacyMarkFlexi'));
export const ERx = createDeferredScreen(() => import('./pharmacy/ERx/ERx'));

export const AnalyticsDashboard = createDeferredScreen(() => import('./pharmacy/analytics/analyticsDashboard'));
export const UploadPics = createDeferredScreen(() => import('./pharmacy/Accountability/uploadPics'));

export const AdminPayroll = createDeferredScreen(() => import('./pharmacy/payroll/adminPayroll'));
export const BookkeeperMobileLogin = createDeferredScreen(() => import('./pharmacy/payroll/bookkeeperMobileLogin'));
export const Accounts = createDeferredScreen(() => import('./pharmacy/payroll/accounts'));
export const PayrollSignature = createDeferredScreen(() => import('./pharmacy/payroll/payrollSignature'));

export const SuperNova = createDeferredScreen(() => import('./pharmacy/dispense/superNova'));
export const SuperNovaWithOtpGate = createDeferredScreen(() => import('./pharmacy/dispense/SuperNovaWithOtpGate'));
export const HalfBaked = createDeferredScreen(() => import('./pharmacy/dispense/halfBaked'));


// export { default as Appreciation } from "./appreciation/appreciation";
// export { default as Dashboard } from "./dashboard/dashboard";
// export { default as PharmacyBookMarksList } from './dashboard/bookmarks/bookmarkList'
// export { default as ChangeLog } from "./changeLog/changeLog";

// export { default as AllRequests } from "./timeOffRequest/allRequests";
// export { default as NewRequest } from "./timeOffRequest/newRequest";
// export { default as TimeSchedule } from "./timeSheet/timeSchedule";

// export { default as MyProfile } from "./myProfile/myProfile";
// export { default as AddPatients } from "./pharmacy/patients/addPatients";
// export { default as PharmacyPatientProfile } from "./pharmacy/patients/patientProfile";
// export { default as Settings } from "./settings/settings";
// export { default as AllEmployees } from "./teams/employees/allEmployees";
// export { default as EditRequest } from "./timeOffRequest/editRequest";
// export { default as AllPatientsList } from "./pharmacy/patients/patientsList";
// export { default as PharmacyPrintOatLog } from "./pharmacy/patients/printOatLog";

// //Forms
// export { default as RxTransferForm } from "./pharmacy/forms/RxTransferRequest";
// export { default as PharmacyInformationUpdateForm } from "./pharmacy/forms/pharmacyInformationUpdateForm";
// export { default as DrNotificationForEmergencySupply } from "./pharmacy/forms/DrNotificationforEmergencySupply";
// export { default as MixingRxRequirementsForm } from "./pharmacy/forms/MissingRxRequirementsForm";
// export { default as AntiViralRequestForm } from "./pharmacy/forms/antiViralRequestForms";
// export { default as EmergencySupplyForContinuityOfCareForm } from "./pharmacy/forms/EmergencySupplyForContinuityofCareForm";
// export { default as PatientAgreementForTakeHomeDosing } from "./pharmacy/forms/PatientAgreementForTakeHomeDosing";
// export { default as DoctorCommunicationForm } from "./pharmacy/forms/doctorCommunicationForm";
// export { default as PlanGForm } from "./pharmacy/forms/planGForm";
// export { default as PlanZForm } from "./pharmacy/forms/planZForm";
// export { default as AddDoctorNote } from "./pharmacy/forms/AddDr_noteForm";
// export { default as TBSkinMantouxForm } from './pharmacy/forms/TBSkinTest(Mantoux Test)ReportForm'
// export { default as TbSkinTestLogs } from './pharmacy/forms/TbSkinTestLogs'
// export { default as PharmacistPrescriberCommunication } from "./pharmacy/forms/pharmacistPrescriberCommunication";
// export { default as RxCopyOfOriginalForOatDD } from "./pharmacy/forms/RxCopyOriginalforOAT_DD";
// export { default as TBScreeningForm } from "./pharmacy/forms/Tb_screening_form";
// export { default as TbScreeningFormsLogs } from "./pharmacy/forms/Tb_sscreening_forms_logs";
// export { default as Pharmacare } from "./pharmacy/forms/pharmacare";
// //Forms

// //Pharmacy Dashboard
// export { default as PharmacyEmployeesTaskList } from "./pharmacy/dashboard/tasksList";
// export { default as PharmacyTeamNotes } from "./pharmacy/dashboard/teamNotes";
// export { default as GeneralInformation } from "./pharmacy/others/generalInformation";
// export { default as AllNotifications } from "./pharmacy/dashboard/allNotifications";
// export { default as SentFaxLogs } from "./pharmacy/dashboard/sentFaxLogs";
// export { default as ReminderNotifications } from './pharmacy/dashboard/newReminderNotifications';
// //Pharmacy Dashboard


// export { default as PharmacyFrontProfile } from "./settings/pharmacyProfile";

// export { default as CompoundAggrementForm } from "./pharmacy/compounds/compoundAggrementForm";
// export { default as EditCompoundPriceList } from "./pharmacy/compounds/editCompoundPriceList";
// export { default as CompoundPriceList } from "./pharmacy/compounds/priceList";

// export { default as CompoundOrderForm } from "./pharmacy/compounds/CompoundOrderForm";
// export { default as ControlledSubstancesOrderRequestForm } from "./pharmacy/compounds/ControlledSubstancesOrderRequestForm";
// export { default as OrderCompoundingForm } from "./pharmacy/compounds/compoundingOrder";
// export { default as CompoundQuotation } from "./pharmacy/compounds/compoundQuotation";
// // export { default as CompoundDins } from "./pharmacy/compounds/compoundDins";
// // export { default as CompoundLogs } from "./pharmacy/compounds/compoundLogs";
// export { default as CompoundDueBilling } from "./pharmacy/compounds/compoundDueBilling";

// // Dispense Routes
// export { default as DeliveryDeriverManagement } from "./pharmacy/dispense/deliveryDeriverManagement";
// export { default as ArchivedDispense } from "./pharmacy/dispense/archivedDelivery";
// export { default as DeliveryLabels } from "./pharmacy/dispense/deliveryLabels";
// export { default as PharmacyMemo } from './pharmacy/dispense/pharmacyMemo';
// export { default as SignCheckAI } from "./pharmacy/dispense/signCheckAI";
// export { default as ExpiringRx } from './pharmacy/dispense/expiringRx';
// export { default as ExpiringRxV2 } from './pharmacy/dispense/expiringRxV2';
// export { default as ConsentSubmissions } from './pharmacy/dispense/consentSubmissions';
// export { default as Counselling } from './pharmacy/dispense/counselling';
// export { default as BillingList } from './pharmacy/dispense/billing';
// export { default as PrescriptionsList } from './pharmacy/dispense/prescripitions';
// export { default as OnGoingPrescriptions } from './pharmacy/dispense/onGoingPrescripitions';
// export { default as ReturnedFentanylPatches } from './pharmacy/dispense/returnedFentanylPatches';
// export { default as TransferConsentsForms } from './pharmacy/dispense/transferConsents';
// export { default as Accountability } from './pharmacy/dispense/accountability';
// export { default as PharmacyDWIPatientsData } from './pharmacy/dispense/DWI_PatientsData';
// export { default as PharmacyInvestigationRX } from './pharmacy/dispense/investigationRX';
// export { default as AddNewPharmacistSignatures } from './pharmacy/dispense/pharmacistSignatureUpdation'
// export { default as uploadePrescription } from './pharmacy/dispense/uploadePrescription'
// export { default as PharmacyReversedDelveries } from "./pharmacy/dispense/PharmacyReversedDelveries";
// export { default as PharmacyPatientSoapNotes } from "./pharmacy/dispense-SoapNotes/patientSoapNotes";
// export { default as PharmacyInvestigationRXSignatureRequested } from "./pharmacy/dispense/investigatingRX_SignaturesRequested";
// export { default as MedReviewLogs } from "./pharmacy/dispense-SoapNotes/medReviewLogs";
// export { default as CreateSoapNotes } from "./pharmacy/dispense-SoapNotes/createSoapNotes";
// export { default as SoapNotesLogs } from "./pharmacy/dispense-SoapNotes/soapNotesLogs";
// export { default as MedReviewLog } from "./pharmacy/dispense-SoapNotes/medReviewLog";
// export { default as PatientMedReviewSign } from "./pharmacy/dispense-SoapNotes/patientMedReviewSign";
// // Dispense Routes

// //Blisters
// export { default as AddBlisterPack } from './pharmacy/blisters/addBlisterPack';
// export { default as BlisterPatients } from './pharmacy/blisters/blisterPatientsList';
// export { default as BlistersPackList } from './pharmacy/blisters/blisterPacks';
// export { default as DailyPacksList } from './pharmacy/blisters/dailyPacks';
// export { default as BlisterPacksOnShelf } from './pharmacy/blisters/blisterPacksOnShelf';
// // export { default as BlisterSheets } from './pharmacy/blisters/blisterSheets';
// export { default as BlisterSheets } from './pharmacy/blisters/newBlisterSheet';
// export { default as OldBlisterSheets } from './pharmacy/blisters/blisterSheets';
// //Blisters

// //Vials
// export { default as VialsPatients } from './pharmacy/vials/vialsPatientList';
// export { default as AddVialsPatient } from './pharmacy/vials/addVialsPack';
// export { default as VialsPackList } from './pharmacy/vials/vialsPackList';
// export { default as DailyVialsList } from './pharmacy/vials/dailyVials';
// //Vials

// //Medication
// export { default as MedicationPatients } from './pharmacy/specialityMedication/medicationsPatients';
// export { default as AddMedicationPatients } from './pharmacy/specialityMedication/addMedicationPack';
// export { default as SpecialtyMedicationPackList } from './pharmacy/specialityMedication/specialityMedicationPacks';
// export { default as DailySpecialityMedicationList } from './pharmacy/specialityMedication/dailySpecialityMedication';
// //Medication

// //Invoice
// export { default as GenerateInvoice } from './pharmacy/Invoice/generateInvoice';
// export { default as PreviousInvoicesList } from './pharmacy/Invoice/previousInvoiceNumber';
// //Invoice


// // ---------------ARV Pages -----------------
// export { default as addARV } from './pharmacy/arv/addARV';
// export { default as ArvList } from './pharmacy/arv/arvList';


// // ---------------Revenue Pages -----------------
// export { default as DailyRevenue } from './pharmacy/revenue/dailyRevenue';
// export { default as CashChange } from './pharmacy/revenue/cashChange';
// export { default as DepositInformation } from './pharmacy/revenue/depositInfo';
// export { default as InHandCashInfo } from './pharmacy/revenue/InHandCash';

// // ---------------FDA Pages -----------------
// export { default as CreateNewFDAForm } from './pharmacy/FDAForms/createNewFDAForm';
// export { default as ALLGeneratedFDAformList } from './pharmacy/FDAForms/allGeneratedFDAForms';
// export { default as ExpiringFDAList } from './pharmacy/FDAForms/expiringFDAFormList';
// export { default as ExpiredFDAList } from './pharmacy/FDAForms/expiredFDAList';

// // ---------------OAT Pages -----------------
// export { default as PatientRoute } from './pharmacy/OAT/patientRoute'
// export { default as AddOatPatientPack } from './pharmacy/OAT/addOatPatient'


// // ---------------Inventory Pages -----------------
// export { default as InventoryList } from './pharmacy/Inventory/inventorylist';
// // export { default as TotalReversedList } from './pharmacy/Inventory/totalReversed';


// // ---------------Travel Pages -----------------
// export { default as AddTravelPatients } from './pharmacy/Travel/addTravelPatients'
// export { default as TravelPatients } from './pharmacy/Travel/tarvelPatients'
// export { default as TravelLogs } from './pharmacy/Travel/travelLogs'
// export { default as BillingDueList } from './pharmacy/Travel/billingDue'
// export { default as ReturningPatientsList } from './pharmacy/Travel/returningPatients'

// // ---------------APp PAges-----------------

// export { default as TransferPrescriptions } from './pharmacy/app/transferPrescriptions'
// export { default as NewPrescriptionList } from './pharmacy/app/newPrescription'
// export { default as ViewOrderDetails } from './pharmacy/app/viewOrderDetails'
// export { default as AppUser } from './pharmacy/app/appUserList'
// export { default as RefillRequest } from './pharmacy/app/refillRequest'

// export { default as AppAnnouncements } from './pharmacy/app/appAnnouncements'
// export { default as AppCustomNotification } from './pharmacy/app/appCustomNotification'
// export { default as BreakPayrollSetting } from './settings/breakPayrollSetting'


// // ----------------- Settings---------------------
// export { default as PharmacyStatHolidays } from './settings/pharmacyStatHolidays'


// // ----------------- Appointments---------------------
// export { default as BookAppointments } from './pharmacy/appointments/bookAppointments'
// export { default as AppointmentLogs } from './pharmacy/appointments/appointmentLogs'

// // ----------------- Pacakging---------------------
// export { default as PackagingOrderPreview } from './pharmacy/packaging/packagingOrderPreview'
// export { default as CreateNewOrder } from './pharmacy/packaging/createNewOrder'
// export { default as AllPackagingOrders } from './pharmacy/packaging/allPackagingOrders'
// export { default as MyPackmedFiles } from './pharmacy/packaging/myPackmedFiles'
// export { default as PackgingLiquidProcessing } from './pharmacy/packaging/liquidProcessing'
// export { default as PackgingPRNProcessing } from './pharmacy/packaging/PRN_Processing'
// export { default as AllInvoices } from './pharmacy/packaging/All_Invoices'
// export { default as PackagingMonthlyInvoice } from './pharmacy/packaging/monthlyInvoice'

// // ----------------- Vaccinattion---------------------
// // export { default as VaccinePassPort } from './pharmacy/vaccines/vaccinePassport'
// export { default as VaccinePassPort } from './pharmacy/vaccines/newVaccinePass_port'
// export { default as VaccineLogs } from './pharmacy/vaccines/vaccineLogs'

// // ----------------- SMS---------------------
// export { default as PharmacySmsTabs } from './pharmacy/sms/smsTabs'

// // ----------------- Blister Packaging---------------------
// export { default as CreateBlisterPackagingNewOrder } from './pharmacy/blisterPackaging/createNewOrder'
// export { default as BlisterPackgingPRNProcessing } from './pharmacy/blisterPackaging/PRN_Processing'
// export { default as BlisterPackgingLiquidProcessing } from './pharmacy/blisterPackaging/liquidProcessing'
// export { default as BlisterPackagingAllOrders } from './pharmacy/blisterPackaging/allPackagingOrders'
// export { default as BlisterPackagingPackmedFiles } from './pharmacy/blisterPackaging/myPackmedFiles'
// export { default as BlisterPackagingAllInvoices } from './pharmacy/blisterPackaging/All_Invoices'
// export { default as BlisterPackagingMonthlyInvoice } from './pharmacy/blisterPackaging/monthlyInvoice'
// // ----------------- Blister Packaging---------------------1

// // ----------------- Accountability Account ---------------------
// export { default as AccountabilityNewRx } from './pharmacy/Accountability/accountabilityNewRx'
// export { default as PrepCheck } from './pharmacy/Accountability/preparingCheck'
// export { default as PickupLog } from './pharmacy/Accountability/preparingCheckPickupLog'
// export { default as FinalCheck } from './pharmacy/Accountability/finalCheck'
// export { default as TodayMissedRx } from './pharmacy/Accountability/todayMissedRx'
// export { default as AccountabilityAllReports } from './pharmacy/Accountability/accountabilityAllReports'
// export { default as PrepForNewRx } from './pharmacy/Accountability/prepForNewRx'
// export { default as AfterProcessPrepCheck } from './pharmacy/Accountability/afterProcessPrepCheck/AfterProcessPrepCheck'
// export { default as PharmacyMarkFlexi } from './pharmacy/Accountability/pharmacyMarkFlexi/PharmacyMarkFlexi'
// export { default as ERx } from './pharmacy/ERx/ERx'

// // ----------------- Analytics---------------------
// export { default as AnalyticsDashboard } from './pharmacy/analytics/analyticsDashboard'
// export { default as UploadPics } from './pharmacy/Accountability/uploadPics'

// // ----------------- Payroll---------------------
// export { default as AdminPayroll } from './pharmacy/payroll/adminPayroll'
// export { default as BookkeeperMobileLogin } from './pharmacy/payroll/bookkeeperMobileLogin'
// export { default as Accounts } from './pharmacy/payroll/accounts'
// export { default as PayrollSignature } from './pharmacy/payroll/payrollSignature'
// export { default as SuperNova } from './pharmacy/dispense/superNova'
// export { default as SuperNovaWithOtpGate } from './pharmacy/dispense/SuperNovaWithOtpGate'
